import React from 'react';
import styles from './Chip.scss';
import { IconCheck } from '@justgiving/carepack-icons';

export type IProps = {
  label: string;
  value: string;
  checked: boolean;
  onClick: (e: any) => void;
};

const Chip: React.FC<IProps> = ({ label, value, checked, onClick }) => {
  return (
    <>
      <input
        id={value}
        type="checkbox"
        name={value}
        onClick={() => onClick(value)}
        checked={checked}
      />

      <label htmlFor={value} className={styles.chip}>
        <IconCheck className={styles.icon} />
        {label}
      </label>
    </>
  );
};

export default Chip;
